import { create } from 'zustand'

interface BellAnimationStore {
  isWiggling: boolean
  triggerWiggle: () => void
  stopWiggle: () => void
}

export const useBellAnimationStore = create<BellAnimationStore>((set) => ({
  isWiggling: false,
  triggerWiggle: () => {
    set({ isWiggling: true })
    setTimeout(() => set({ isWiggling: false }), 2500)
  },
  stopWiggle: () => set({ isWiggling: false }),
}))
